function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import { Sides } from './constants';
/**
 * stopTransitionOnSideChange
 * @param {ReactComponent} WrappedComponent
 * HOC that checks whether the `side` prop has changed,
 * and if so, prevents the element from transitioning
 * (to prevent odd style animations).
 */

var stopTransitionOnSideChange = function stopTransitionOnSideChange(WrappedComponent) {
  var StoppedTransition =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(StoppedTransition, _React$Component);

    function StoppedTransition(props) {
      var _this;

      _classCallCheck(this, StoppedTransition);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(StoppedTransition).call(this, props)); // Can put this on instance, since this
      // is recomputed on each componentWillReceiveProps

      _this.shouldAnimate = props.shouldAnimate;
      return _this;
    }

    _createClass(StoppedTransition, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.side !== this.props.side) {
          this.shouldAnimate = false;
        } else {
          this.shouldAnimate = nextProps.shouldAnimate;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, _extends({}, this.props, {
          shouldAnimate: this.shouldAnimate
        }));
      }
    }]);

    return StoppedTransition;
  }(React.Component);

  _defineProperty(StoppedTransition, "propTypes", {
    side: PropTypes.oneOf(Object.values(Sides)),
    shouldAnimate: PropTypes.bool
  });

  var name = WrappedComponent.displayName || WrappedComponent.name;
  StoppedTransition.displayName = "StoppedTransition(".concat(name, ")");
  return StoppedTransition;
};

export default stopTransitionOnSideChange;